import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RenderViewComponent } from '../render-view/render-view.component';
import { EffectPickerComponent } from '../effect-picker/effect-picker.component';
import { PropertiesListComponent } from '../properties-list/properties-list.component';
import { LayerListComponent } from '../layer-list/layer-list.component';
import { BaseState } from '../../reducers';
import { Observable, combineLatest, map } from 'rxjs';
import { selectLayerOrder, selectLayers, selectRenderName, selectSelectedEffect, selectSelectedLayer } from '../store/editor.selector';
import { CommonModule } from '@angular/common';
import { cloneLayer, deleteLayer, changeLayerOrder, setSelectedLayer, toggleLayerVisibility, toggleShowEffects, updateLayer, addEffectOrEffectLayer, deleteEffect, selectEffect, updateRenderName, defaultEditorState, moveLayer, moveEffect } from '../store/editor.actions';
import { Layer } from '../models/layer.model';
import { HttpClientModule } from '@angular/common/http';
import { UIEffectItem } from '../models/ui-effects.model';
import { PresetListComponent } from '../preset-list/preset-list.component';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogService } from 'primeng/dynamicdialog';
import { CreatePresetDialogComponent } from '../create-preset-dialog/create-preset-dialog.component';
import { driver } from 'driver.js'
import driverModel from '../models/driver.model';
import { Router } from '@angular/router';
import { MoveLayerDirection } from '../models/properties.model';

@Component({
  selector: 'app-render-grid',
  standalone: true,
  imports: [
    RenderViewComponent,
    EffectPickerComponent,
    PropertiesListComponent,
    LayerListComponent,
    CommonModule,
    HttpClientModule,
    PresetListComponent,
    ButtonModule,
    TooltipModule
  ],
  templateUrl: './render-grid.component.html',
  styleUrl: './render-grid.component.scss',
  providers: [DialogService],
})
export class RenderGridComponent {
  selectedLayer$ = this.store.select(selectSelectedLayer)
  layers$ = this.store.select(selectLayers)
  layerOrder$ = this.store.select(selectLayerOrder)
  renderName$ = this.store.select(selectRenderName)
  selectedEffectId$ = this.store.select(selectSelectedEffect)
  effectsList$ = combineLatest([this.layers$, this.selectedLayer$]).pipe(
    map(([layers, selectedLayer]) => {
      if (selectedLayer && layers[selectedLayer]) {
        return layers[selectedLayer].effects
      }
      return []
    })
  )

  isDemo = this.router.getCurrentNavigation()?.extractedUrl.toString().includes("demo")

  constructor(
    private store: Store<BaseState>,
    private dialog: DialogService,
    private router: Router
  ){}

  setSelectedLayer(layerId: string | undefined) {
    this.store.dispatch(setSelectedLayer({layerId}))
  }
  toggleShowEffects(layerId: string) {
    this.store.dispatch(toggleShowEffects({layerId}))
  }
  toggleLayerVisibility(layerId: string) {
    this.store.dispatch(toggleLayerVisibility({layerId}))
  }
  deleteLayer(layerId: string) {
    this.store.dispatch(deleteLayer({layerId}))
  }
  cloneLayer(layerId: string) {
    this.store.dispatch(cloneLayer({layerId}))
  }
  changeLayerOrder(event: {id: string, index: number}) {
    this.store.dispatch(changeLayerOrder(event))
  }
  updateLayer(event: {layerId: string, layer: Layer}){
    this.store.dispatch(updateLayer(event))
  }
  deleteEffect(event: {layerId: string, effectId: string}){
    this.store.dispatch(deleteEffect(event))
  }
  addEffectToLayer(event: UIEffectItem){
    this.store.dispatch(addEffectOrEffectLayer({layer: event}))
  }
  selectEffect(effectId: string | undefined){
    this.store.dispatch(selectEffect({effectId}))
  }
  changeRenderName(name: string) {
    this.store.dispatch(updateRenderName({name}))
  }
  openPresetDialog() {
    this.dialog.open(CreatePresetDialogComponent, {
      header: 'Create Preset',
      width: 'min(30%, 400px)',
    })
  }
  resetEditorState() {
    this.store.dispatch(defaultEditorState())
  }
  startHelperDriver() {
    driverModel.drive()
  }
  moveLayer(event$: {direction: MoveLayerDirection, layerId: string}) {
    this.store.dispatch(moveLayer(event$))
  }

  moveEffect(event$: {direction: MoveLayerDirection, effectId: string, layerId: string}) {
    this.store.dispatch(moveEffect(event$))
  }
}
